/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import AppRoutes from 'AppRoutes';
import { ErrorFallback } from 'components/common/Error/ErrorFallback';
import { getDefaultStore } from 'jotai';
import { customColorAtomFamily } from 'jotai/customColor';
import { vehicleColors } from 'jotai/vehicleColor';
import { Suspense, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { authService } from 'services/auth/AuthService';
import './index.scss';

const App = () => {
  const defaultStore = getDefaultStore();
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    authService.isInitialized().then((response) => {
      setIsInitialized(response);
    });
    vehicleColors.forEach((color) => defaultStore.set(customColorAtomFamily(color.id), color));
  }, [defaultStore]);

  // hide header if user is not logged in or if user is not authorized
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading Application...</div>}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>{isInitialized && <AppRoutes />}</ErrorBoundary>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
